"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NoResults;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function NoResults(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? "Nenalezeny žádné výsledky" : _ref$text;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, text);
}
//# sourceMappingURL=NoResults.js.map